import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { usersRoute } from 'src/app/app-routing.module';
import { EntityRegisterView } from 'src/app/common-components/register/models/register-view';
import { UserPrivileges } from '../../user-details/models/user-privileges';
import { UserOrderingOptions, UserRegisterOptions } from '../models/user-register-options';
import { UserRegisterListItem } from '../models/user-register-results.model';
import { selectQuickFilters } from '../state/user-register.reducer';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-user-register-view',
    styleUrls: ['./user-register-view.component.scss'],
    templateUrl: './user-register-view.component.html',
    standalone: false
})
export class UserRegisterViewComponent extends EntityRegisterView<
   UserRegisterListItem,
   UserRegisterOptions,
   UserOrderingOptions
> {
   protected selectQuickFilters(): (state: object) => UserRegisterOptions | null {
      return selectQuickFilters;
   }
   protected override onQuickFiltersInit(quickFilters: UserRegisterOptions): void {
      if (this.route === 'systemusers') {
         if (quickFilters) {
            this.showAllUsers = quickFilters.showAllUsers;
         }
      }
      this.includeInactive = quickFilters.includeInactive ?? false;
   }
   @Input() userPrivileges: UserPrivileges;

   @Input() includeInactive: boolean;

   @Input() route: string;

   @Output() showAllUsersChanged = new EventEmitter<boolean>();

   @Output() includeInactiveChanged = new EventEmitter<boolean>();

   @Input() showAllUsers = false;

   defaultRoute = usersRoute;

   getRouterLink(id: number) {
      return `/${this.route ?? usersRoute}/${id}`;
   }

   showAllUsersChange(showAllUsersSelected: boolean): void {
      this.registerOptions = { ...this.registerOptions, showAllUsers: showAllUsersSelected };
      this.quickFilterChange.emit(this.registerOptions);
   }

   includeInactiveChange(includeInactiveSelected: boolean): void {
      this.registerOptions = { ...this.registerOptions, includeInactive: includeInactiveSelected };
      this.quickFilterChange.emit(this.registerOptions);
      this.includeInactiveChanged.emit(includeInactiveSelected);
   }
}
